import { observer } from 'mobx-react-lite';
import { Grid, Header, List, Segment } from 'semantic-ui-react';
import { Permit } from '../../../app/models/permit';
import { useStore } from '../../../app/stores/store';
import { getSailingTime, weekDays } from '../../../app/common/util/util';

interface Props {
    permit: Permit
}

export default observer(function PermitDetailedInfoSchedule1({ permit }: Props) {
    const {permitStore} = useStore();
    const {
        getAmTimeByDay,
        getPmTimeByDay,
        getTerminalName,
    } = permitStore;

    return (
        <>
            <Segment basic className='clear-both'>
                <Grid>
                    <Grid.Column computer={8} tablet={8} mobile={16}>
                        <Header 
                            as='h3'
                            content={`Leave ${getTerminalName('' + permit.amTerminalId)}`}
                            block
                            inverted
                            textAlign='center'
                        />
                        <List relaxed celled size='big'>
                            {permit.amTimes && permit.amTimes
                                .filter(x => x.isSelected)
                                .map((x, i) => {
                                return (
                                    <List.Item 
                                        key={`am-${i}`}
                                        className='text-center'
                                    >{weekDays[x.dayId - 1]} {getSailingTime(getAmTimeByDay(x.dayId), x.permitRoutetimeId)}</List.Item>
                                )
                            })}
                        </List>
                    </Grid.Column>
                    <Grid.Column computer={8} tablet={8} mobile={16}>
                        <Header 
                            as='h3'
                            content={`Leave ${getTerminalName('' + permit.pmTerminalId)}`}
                            block
                            inverted
                            textAlign='center'
                        />
                        <List relaxed celled size='big'>
                            {permit.pmTimes && permit.pmTimes
                                .filter(x => x.isSelected)
                                .map((x, i) => {
                                return (
                                    <List.Item 
                                        key={`pm-${i}`}
                                        className='text-center'
                                    >{weekDays[x.dayId - 1]} {getSailingTime(getPmTimeByDay(x.dayId), x.permitRoutetimeId)}</List.Item>
                                )
                            })}
                        </List>
                    </Grid.Column>
                </Grid>
            </Segment>
        </>
    )
})